
@if (isLoading$ | async) {
    <app-loading-indicator></app-loading-indicator>
} @else {
    @if ((secontTaskList$ | async)?.length === 0) {
        <app-card [noMargin]="true" [showHeader]="false">
            <div card-body>
                @if (isAsap) {
                    <app-empty-state
                        title="No Reports Yet"
                        message="Any incomplete reports will appear here until they are finished and submitted.">
                    </app-empty-state>
                } @else {
                    <app-empty-state illustration="search">
                    </app-empty-state>
                }
            </div>
        </app-card>
    } @else {
        <div class="flights-list-wrapper">
            @for (task of secontTaskList$ | async; track task.data._id) {
                @switch (task.type) {
                    @case ("flight") {
                        <app-home-task-card
                            [flight]="task.data"
                            [showEdit]="false"></app-home-task-card>
                    }
                    @case ("promotion") {
                        <app-promotion-task-card
                            [promotion]="task.data">
                        </app-promotion-task-card>
                    }
                    @case ("issue") {
                        <app-issue-task-card
                            [issue]="task.data">
                        </app-issue-task-card>
                    }
                    @case ("task") {
                        <app-task-card
                            [task]="task.data"
                            [showEdit]="false">
                        </app-task-card>
                    }
                    @case ("audit") {
                        <app-audit-task-card
                            [audit]="task.data">
                        </app-audit-task-card>
                    }
                    @case ("riskEvaluation") {
                        <app-risk-evaluation-task-card
                            [riskEvaluation]="task.data">
                        </app-risk-evaluation-task-card>
                    }
                }
            }
        </div>

        @if (total > pageSize) {
            <div class="list-footer">
                <span class="list-footer__report">{{ visibleRangeLabel }}</span>
                <p-paginator
                    styleClass="assigned-items-paginator"
                    (onPageChange)="onPageChange($event)"
                    [first]="currentPage * pageSize"
                    [rows]="pageSize"
                    [totalRecords]="total"
                    [showCurrentPageReport]="false"
                    [showPageLinks]="false"
                    [showJumpToPageDropdown]="true">
                </p-paginator>
            </div>
        }
    }
}
